// Per-widget checkout appearance, stored in settings.checkout_presentation.
// Missing settings preserve the existing checkout; choosing Welcome is opt-in.
export type CheckoutPresentation = {
  layout: "classic" | "welcome";
  heading: string;
  description: string;
  show_summary_images: boolean;
};

export const CHECKOUT_HEADING_MAX_LENGTH = 120;
export const CHECKOUT_DESCRIPTION_MAX_LENGTH = 320;

export const DEFAULT_CHECKOUT_PRESENTATION: Readonly<CheckoutPresentation> = {
  layout: "classic",
  heading: "Your visit starts here",
  description: "First, tell us who is booking.",
  show_summary_images: true,
};

function copy(value: unknown, fallback: string, maxLength: number): string {
  if (typeof value !== "string") return fallback;
  // This is plain text, never HTML. Keep deliberate blank copy so tenants can
  // hide either line. Remove control characters and keep a bounded one-line
  // value; React renders any markup-shaped text literally.
  return Array.from(value.replace(/[\u0000-\u001f\u007f-\u009f]/g, " ").trim())
    .slice(0, maxLength)
    .join("");
}

export function resolveCheckoutPresentation(
  value: unknown,
): CheckoutPresentation {
  const stored =
    value !== null && typeof value === "object" && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : {};
  return {
    layout: stored.layout === "welcome" ? "welcome" : "classic",
    heading: copy(
      stored.heading,
      DEFAULT_CHECKOUT_PRESENTATION.heading,
      CHECKOUT_HEADING_MAX_LENGTH,
    ),
    description: copy(
      stored.description,
      DEFAULT_CHECKOUT_PRESENTATION.description,
      CHECKOUT_DESCRIPTION_MAX_LENGTH,
    ),
    show_summary_images:
      typeof stored.show_summary_images === "boolean"
        ? stored.show_summary_images
        : DEFAULT_CHECKOUT_PRESENTATION.show_summary_images,
  };
}
